import ky from 'ky';
import authState from '../store/auth';
import { get } from 'svelte/store';
import { AmplitudeLogger, EVENTS } from "./utils"

const decodeToken = (token) => {
    try {
        // if the token has more or less than 3 parts or is not a string
        // then is not a valid token
        if (token.split('.').length !== 3 || typeof token !== 'string') {
            return null;
        }

        const payload = token.split('.')[1];

        const base64 = payload.replace('-', '+').replace('_', '/');
        const decoded = JSON.parse(atob(base64));

        return decoded;
    } catch (error) {
        return null;
    }
};

const isTokenExpired = (token) => {
    const decodedToken = decodeToken(token);
    let result = true;
    if (decodedToken && decodedToken.exp) {
        const expirationDate = new Date(0);

        expirationDate.setUTCSeconds(decodedToken.exp); // sets the expiration seconds
        // compare the expiration time and the current time

        const now = new Date();
        now.setSeconds(now.getSeconds() + 10);
        //a safe bracket of ten seconds

        result = expirationDate.valueOf() < now.valueOf();
    } else {
        result = true;
    }

    return result;
};

const publicClient = ky.create({
    prefixUrl: 'https://api.pressone.co/api/',
    headers: { Accept: 'application/json' },
    credentials: 'include',
    retry: {
        limit: 0, // no retries
    },
    hooks: {
        afterResponse: [
            async (_req, _opt, response) => {
                if (!response.ok) {
                    response.data = await response.json();
                    return response;
                }
            },
        ],
    },
});

const privateClient = publicClient.extend({
    hooks: {
        beforeRequest: [
            async (request) => {

                const accessToken = get(authState).accessToken;
                const isExpired = isTokenExpired(accessToken);

                if (isExpired) {
                    try {
                        const response = await publicClient.post(`token/refresh/`).json();
                        authState.refresh(response.data);

                        request.headers.set(
                            'Authorization',
                            `Bearer ${response.data.token}`
                        );
                        return request;
                    } catch (error) {
                        // TODO: handle error by redirecting to login page
                        // console.error(error);
                        // console.error('failed to refresh token');
                    }
                }

                if (accessToken) {
                    request.headers.set('Authorization', `Bearer ${accessToken}`);
                }
                return request;
            },
        ],
    },
});

const PUBLIC_CLIENT = 'public';
const PRIVATE_CLIENT = 'private';

class Client {
    constructor() {
        this.publicClient = publicClient;
        this.privateClient = privateClient;
    }

    async request(method, url, level = 'private', payload, query) {
        const clientToUse =
            level === PRIVATE_CLIENT ? this.privateClient : this.publicClient;

        try {
            const response = await clientToUse(url, {
                method,
                searchParams: query,
                json: method.toUpperCase() === 'GET' ? undefined : payload,
            });

            return response.json();
        } catch (error) {
            // console.dir(error)
            if (error.response) {
                const _error = error.response.data;
                // toast.error(_error);
                // throw _error;
                AmplitudeLogger.log(EVENTS.ERROR_LOG, _error)
            } else {
                const _error = {
                    code: 'INTERNAL_ERROR',
                    message:
                        'Something went wrong, Please check your internet connection and try again',
                    data: null,
                    status: false,
                };
                // toast.error(_error);
                // throw _error;
                AmplitudeLogger.log(EVENTS.ERROR_LOG, _error)
            }
        }
    }

    async get(...args) {
        return this.request('get', ...args);
    }

    async post(...args) {
        return this.request('post', ...args);
    }

    async patch(...args) {
        return this.request('patch', ...args);
    }

    async put(...args) {
        return this.request('patch', ...args);
    }

    async delete(...args) {
        return this.request('delete', ...args);
    }
}

export { PRIVATE_CLIENT, PUBLIC_CLIENT };

export default new Client();
